import React from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
// import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import DialogContentText from "@material-ui/core/DialogContentText";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";

export default class EditPlayersDialog extends React.Component {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth="xl"
      >
        <DialogTitle id="form-dialog-title">
          {this.props.addPlayer || this.props.players.length === 0
            ? languages.teams.addPlayer
            : this.props.selectedPlayer
            ? languages.teams.editPlayer
            : languages.teams.players}
        </DialogTitle>
        <Typography variant="caption" style={{ padding: "0px 24px 10px 24px" }}>
          {languages.formatString(
            languages.teams.addPlayerDescription1,
            this.props.team.name
          ) +
            ". " +
            languages.teams.addPlayerDescription2}
        </Typography>
        <DialogContent>
          {/* <DialogContentText>{languages.teams.players}</DialogContentText> */}
          {this.props.addPlayer ||
          this.props.players.length === 0 ||
          this.props.selectedPlayer ? (
            <div>
              {!this.props.selectedPlayer && (
                <Tabs
                  value={this.state.value}
                  onChange={this.handleChange}
                  indicatorColor="primary"
                  textColor="primary"
                  scrollButtons="off"
                  variant="fullWidth"
                  style={{ marginBottom: 10 }}
                >
                  <Tab
                    key={0}
                    label={languages.teams.singlePlayer}
                    style={{ height: 40 }}
                  />
                  <Tab
                    key={1}
                    label={languages.teams.multiplePlayers}
                    style={{ height: 40 }}
                  />
                </Tabs>
              )}
              {(this.state.value === 0 || this.props.selectedPlayer) && (
                <div>
                  <TextField
                    autoFocus
                    margin="dense"
                    label={languages.general.name}
                    value={this.props.name}
                    name="name"
                    onChange={this.props.handleChange}
                    type="text"
                    fullWidth
                  />
                  {((
                    (this.props.tournament.infoFieldsPlayers || {})["age"] || {}
                  ).show === undefined ||
                    (
                      (this.props.tournament.infoFieldsPlayers || {})["age"] ||
                      {}
                    ).show === true) && (
                    <TextField
                      margin="dense"
                      label={
                        (
                          (this.props.tournament.infoFieldsPlayers || {})[
                            "age"
                          ] || {}
                        ).name !== undefined
                          ? (
                              (this.props.tournament.infoFieldsPlayers || {})[
                                "age"
                              ] || {}
                            ).name
                          : languages.teams.age
                      }
                      value={this.props.age}
                      name="age"
                      onChange={this.props.handleChange}
                      type="text"
                      fullWidth
                    />
                  )}
                  {((
                    (this.props.tournament.infoFieldsPlayers || {})["number"] ||
                    {}
                  ).show === undefined ||
                    (
                      (this.props.tournament.infoFieldsPlayers || {})[
                        "number"
                      ] || {}
                    ).show === true) && (
                    <TextField
                      margin="dense"
                      label={
                        (
                          (this.props.tournament.infoFieldsPlayers || {})[
                            "number"
                          ] || {}
                        ).name !== undefined
                          ? (
                              (this.props.tournament.infoFieldsPlayers || {})[
                                "number"
                              ] || {}
                            ).name
                          : languages.teams.number
                      }
                      value={this.props.number}
                      name="number"
                      onChange={this.props.handleChange}
                      type="text"
                      fullWidth
                    />
                  )}
                  {Object.keys(this.props.tournament.infoFieldsPlayers || {})
                    .filter(
                      (key) => ["name", "age", "number"].indexOf(key) === -1
                    )
                    .map((key) => {
                      const infoField = Object.assign(
                        {},
                        this.props.tournament.infoFieldsPlayers[key]
                      );
                      return (
                        <TextField
                          key={key}
                          margin="dense"
                          label={infoField.name}
                          value={this.props.infoFields[key] || ""}
                          name={key}
                          onChange={this.props.handleChangeInfoField}
                          type="text"
                          fullWidth
                        />
                      );
                    })}
                  {this.props.selectedPlayer && (
                    <Button
                      onClick={(e) => {
                        this.props.handleDelete(e, this.props.selectedPlayer);
                      }}
                      color="secondary"
                      variant="outlined"
                      style={{ marginTop: 10 }}
                    >
                      {languages.general.delete}
                    </Button>
                  )}
                </div>
              )}
              {this.state.value === 1 && !this.props.selectedPlayer && (
                <div>
                  <DialogContentText>
                    <Typography variant="caption">
                      {languages.teams.multiplePlayersDescription}
                    </Typography>
                  </DialogContentText>
                  <TextField
                    multiline
                    rows="8"
                    onKeyDown={this.props.handleKeyDown}
                    autoFocus
                    margin="dense"
                    label={languages.teams.listOfPlayers}
                    value={this.props.playerList}
                    name="playerList"
                    onChange={this.props.handleChange}
                    type="text"
                    fullWidth
                  />
                </div>
              )}
            </div>
          ) : (
            <div>
              {this.props.players.length > 0 ? (
                <Table>
                  <TableHead>
                    <TableRow>
                      {/* <TableCell style={{ padding: 0 }}></TableCell> */}
                      <TableCell style={{ padding: 0 }}>
                        {languages.general.name}
                      </TableCell>
                      {((
                        (this.props.tournament.infoFieldsPlayers || {})[
                          "age"
                        ] || {}
                      ).show === undefined ||
                        (
                          (this.props.tournament.infoFieldsPlayers || {})[
                            "age"
                          ] || {}
                        ).show === true) && (
                        <TableCell style={{ padding: 0 }}>
                          {(
                            (this.props.tournament.infoFieldsPlayers || {})[
                              "age"
                            ] || {}
                          ).name !== undefined
                            ? (
                                (this.props.tournament.infoFieldsPlayers || {})[
                                  "age"
                                ] || {}
                              ).name
                            : languages.teams.age}
                        </TableCell>
                      )}
                      {((
                        (this.props.tournament.infoFieldsPlayers || {})[
                          "number"
                        ] || {}
                      ).show === undefined ||
                        (
                          (this.props.tournament.infoFieldsPlayers || {})[
                            "number"
                          ] || {}
                        ).show === true) && (
                        <TableCell style={{ padding: 0 }}>
                          {(
                            (this.props.tournament.infoFieldsPlayers || {})[
                              "number"
                            ] || {}
                          ).name !== undefined
                            ? (
                                (this.props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).name
                            : languages.teams.number}
                        </TableCell>
                      )}
                      {Object.keys(
                        this.props.tournament.infoFieldsPlayers || {}
                      )
                        .filter(
                          (key) => ["name", "age", "number"].indexOf(key) === -1
                        )
                        .map((key) => {
                          const infoField = Object.assign(
                            {},
                            this.props.tournament.infoFieldsPlayers[key]
                          );
                          return (
                            <TableCell key={key} style={{ padding: 0 }}>
                              {infoField.name}
                            </TableCell>
                          );
                        })}
                      <TableCell style={{ paddingRight: 0 }}></TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.props.players
                      .sort((a, b) =>
                        a.name.localeCompare(b.name, undefined, {
                          numeric: true,
                          sensitivity: "base",
                        })
                      )
                      .map((player, i) => {
                        return (
                          <TableRow key={this.props.division + i}>
                            {/* <TableCell style={{ padding: 0 }}>
                              {i + 1 + "."}
                            </TableCell> */}
                            <TableCell style={{ padding: 0 }}>
                              {player.name}
                            </TableCell>
                            {((
                              (this.props.tournament.infoFieldsPlayers || {})[
                                "age"
                              ] || {}
                            ).show === undefined ||
                              (
                                (this.props.tournament.infoFieldsPlayers || {})[
                                  "age"
                                ] || {}
                              ).show === true) && (
                              <TableCell style={{ padding: 0 }}>
                                {player.age}
                              </TableCell>
                            )}
                            {((
                              (this.props.tournament.infoFieldsPlayers || {})[
                                "number"
                              ] || {}
                            ).show === undefined ||
                              (
                                (this.props.tournament.infoFieldsPlayers || {})[
                                  "number"
                                ] || {}
                              ).show === true) && (
                              <TableCell style={{ padding: 0 }}>
                                {player.number || ""}
                              </TableCell>
                            )}
                            {Object.keys(
                              this.props.tournament.infoFieldsPlayers || {}
                            )
                              .filter(
                                (key) =>
                                  ["name", "age", "number"].indexOf(key) === -1
                              )
                              .map((key) => {
                                return (
                                  <TableCell key={key} style={{ padding: 0 }}>
                                    {(player.infoFieldsForTable || {})[key] ||
                                      ""}
                                  </TableCell>
                                );
                              })}
                            <TableCell
                              style={{ padding: 0, textAlign: "right" }}
                            >
                              <IconButton
                                aria-label="Change"
                                onClick={(e) => {
                                  this.props.selectPlayer(e, player);
                                }}
                              >
                                <CreateIcon />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              ) : null}
              <Button
                onClick={this.props.toggleAddPlayer}
                color="primary"
                variant="outlined"
                style={{ marginTop: 10 }}
              >
                {languages.teams.addPlayer}
              </Button>
            </div>
          )}
        </DialogContent>
        {this.props.addPlayer ||
        this.props.players.length === 0 ||
        this.props.selectedPlayer ? (
          <DialogActions>
            <Button
              onClick={
                this.props.players.length === 0 && !this.props.selectedPlayer
                  ? this.props.toggleDialog
                  : this.props.back
              }
              color="primary"
            >
              {languages.general.cancel}
            </Button>
            <Button
              onClick={
                this.state.value === 0 || this.props.selectedPlayer
                  ? this.props.handleSubmit
                  : this.props.handleSubmitMultiple
              }
              disabled={this.props.submitDisabled}
              variant="contained"
              color="primary"
              type="submit"
            >
              {this.props.selectedPlayer
                ? languages.general.save
                : languages.general.add}
            </Button>
          </DialogActions>
        ) : (
          <DialogActions>
            <Button onClick={this.props.toggleDialog} color="primary">
              {languages.general.close}
            </Button>
          </DialogActions>
        )}
      </Dialog>
    );
  }
}
